import React, { useEffect } from "react";
import { useState } from "react";
import { CrearRecepcionesApi } from "../Api/CrearRecepcionesApi";
import { ContenedorApi } from "../Api/ContenedorApi";

/**
 * Hook para inicializar el formulario de creación de recepciones.
 * @returns {Object} Objeto con los datos iniciales del formulario.
 */
export const InitForm = () => {
    const [cargandoInicio, setCargandoInicio] = useState(false);

    const {
        vehiculos: vehiculosDefault,
        getVehiculos,
        pilotos: pilotosDefault,
        getPilotos,
    } = CrearRecepcionesApi();

    const {
        getFincas,
        fincas: fincasDefault,
        getTiposMateriaPrima,
        tiposMateriaPrima,
        getProductosLatex,
        productosLatex,
        getProductosSolidos,
        productosSolidos,
    } = ContenedorApi();

    useEffect(() => {
        obtenerData();
    }, [])

    const obtenerData = async () => {
        setCargandoInicio(true);

        await getVehiculos();
        await getPilotos();
        await getFincas();
        await getTiposMateriaPrima();
        await getProductosLatex();
        await getProductosSolidos();

        setCargandoInicio(false);
    }

    return {
        vehiculosDefault,
        pilotosDefault,
        fincasDefault,
        tiposMateriaPrima,
        productosLatex,
        productosSolidos,
        cargandoInicio,
    }
}
